export default function LoadingSpinner({ text = "Đang tải..." }) {
    return (
        <div className="flex flex-col items-center justify-center py-10 text-gray-500">
            <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-red-600 mb-3"></div>
            <p>{text}</p>
        </div>
    );
}
